import BaseDataStore from '@/components/base/store/BaseDataStoreV1'
const BaseConst = {
  version: 1,
  storeName: 'PendingList',
  serviceName: 'C2301ProjectInvestmentInvestService',
  componentDef: {
    table: {
      viewDef: [
        { text: '標題', value: 'c0101_title' },
        { text: '創建者', value: 'm0001_name' },
        { text: '創建時間', value: 'c2301_created_at', type: 'relativeDate' },
        {
          text: '狀態',
          value: 'c2301_status',
          type: 'chip',
          // 'PENDING','IN_PROGRESS','DEAL','SUCCESS','REJECTED','CLOSED','DELETED','REMOVED'
          items: [
            { value: 'PENDING', label: '確認過賬中', color: 'orange' },
            { value: 'IN_PROGRESS', label: '进行中', color: 'blue' },
            { value: 'DEAL', label: '待發票', color: 'orange' },
            { value: 'SUCCESS', label: '已過帳', color: 'green' },
            { value: 'REJECTED', label: '已拒绝', color: 'red' },
            { value: 'CLOSED', label: '已关闭', color: 'red' },
            { value: 'DELETED', label: '已删除', color: 'red' },
            { value: 'REMOVED', label: '已移除', color: 'red' }
          ]
        },
        { text: '審查詳情', value: 'remark', type: 'date' },
        { text: '', value: 'actions' },
        { text: '', value: 'edit' }
      ],
      optionDef: {}
    },
    search: {
      viewDef: [
        {
          column: 'col-4',
          data: 'c0101_title',
          type: 'text',
          label: '標題'
        },
        {
          column: 'col-4',
          data: 'c2301_created_at',
          type: 'date',
          label: '創建時間'
        },
        {
          column: 'col-4',
          label: '狀態',
          data: 'c2301_status',
          type: 'select',
          // 'PENDING','IN_PROGRESS','DEAL','SUCCESS','REJECTED','CLOSED','DELETED','REMOVED'
          props: {
            smallChips: true,
            items: [
              { value: 'PENDING', text: '確認過賬', color: 'orange' },
              { value: 'IN_PROGRESS', text: '进行中', color: 'blue' },
              { value: 'DEAL', text: '待發票', color: 'orange' },
              { value: 'SUCCESS', text: '已過帳', color: 'green' },
              { value: 'REJECTED', text: '已拒绝', color: 'red' },
              { value: 'CLOSED', text: '已关闭', color: 'red' },
              { value: 'DELETED', text: '已删除', color: 'red' },
              { value: 'REMOVED', text: '已移除', color: 'red' }
            ]
          }
        }
      ]
    }
  }
}
const C1001Const = new BaseDataStore(BaseConst)
export default C1001Const
